<template>
  <v-form
		id="newUserForm"
		class="pa-5" 
		ref="form"
		v-model="valid"
  >	
	<v-row v-if="role == 'panelist' ">
		<v-col>
			<v-select
			v-model="subrole"
			label="Panelist Role"
			:items="[{value: 'panelcandidate', text: 'Candidate'}, {value: 'panelmember', text: 'Member'}]"
			></v-select>	
		</v-col>
	</v-row>	
	<v-row>
		<v-col>
			<v-text-field
				v-model="firstName"
				label="First Name"
			></v-text-field> 
		</v-col>

		<v-col>
			<v-text-field
				v-model="lastName"
				label="Last Name"
			></v-text-field> 
		</v-col>
	</v-row>
	<v-row>
		<v-col>
			<v-text-field
				v-model="email"
				:rules="emailRules"
				label="Email"
			></v-text-field> 
		</v-col>

		<v-col>
			<v-text-field
				v-model="phone"
				label="Phone"
			></v-text-field> 
		</v-col>
	</v-row>

	<!-- I have hidden this on purpose - the "claims" are updated when an organisation is added to a user object -> gives access to logo etc -->
	<!-- <v-select label="Organisation" v-model="organisation" :items="organisations" item-value="id" item-text="name" v-if="role == 'client'"></v-select> -->
		<v-dialog
          v-model="errorDialog"
          max-width="290">
          <v-card>
          <v-card-title class="headline">Information</v-card-title>
          <v-card-text> {{errorMessage}}</v-card-text>
          <v-card-actions>
          <v-btn
          color="green darken-1"
          text
          @click="pushUser"
          >
          Add anyway
          </v-btn>
          </v-card-actions>
          </v-card>
        </v-dialog>
    
    <v-btn
		color="error"
		class="mr-4"
		@click="reset"
    >
		Reset Form
    </v-btn>

    <v-btn
		color="success"
		class="mr-4"
		@click="createUser"
    >
		Create User
    </v-btn>
  </v-form>
</template>

<script>
import Vuex from "vuex";
import {deduplicate} from "../../assets/utilities.js";
export default {
	name: 'NewUserForm',
	props: ["role", "preFill"],
	data: () => (
	{
		valid: true,
		emailRules: [
			v => ( v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
		],
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		errorDialog: false,
		subrole: "panelcandidate",
		emailConfirmed: false,
		errorMessage: '',
		organisation: '',
		nameRules: [
			v => !!v || 'Name is required',
		],
	}),
	computed: {
		...Vuex.mapState( {
			// organisations: state => state.admin.organisations
		})
	},
	methods: {
		deduplicate: deduplicate,
		createUser () {
			var self = this;
			if( self.$refs.form.validate() ){
				let userObj = {
					name: self.firstName + " " + self.lastName,
					email: self.email,
					phone: self.phone
				}
				self.deduplicate(userObj).then( response => {
					if( response.unique ){
						this.pushUser()
					}
					else{
						this.errorMessage = "A user with the " + response.key +" "+ userObj[response.key] + " already exists";
						this.errorDialog = true;
					}
				})
			}
		},
		confirmEmail(){
			this.errorMessage = "This will send an email to the user notifying them of account creation";
			this.errorDialog = true;
		},
		pushUser(  ){
			var self = this;
			self.$refs.form.validate()
			if( self.subrole !== 'panelcandidate' ){
				if(!self.emailConfirmed){
						self.confirmEmail();
					self.emailConfirmed	= true;
					return;
				}
			}
			self.errorDialog = false;
			let newUser = {
				"publishStatus": "live",
				'firstName': self.firstName,
				'lastName': self.lastName,
				'displayName': self.firstName + " " + self.lastName,
				'email': self.email,
				'phone': self.phone,
				'role': self.role,
			}
			if(self.role == 'client'){
				newUser.organisation = self.organisation
			}
			if(self.role == 'panelist'){
				newUser.role = self.subrole
			}
			self.$store.dispatch( "addDoc", {
				collection: "users",
				data: newUser
			} ).then( function( ref ){
				self.$refs.form.reset();
				self.$emit("created", ref.id, self.role )

			} );
		},
		reset () {
			this.$refs.form.reset()
		},
		resetValidation () {
			this.$refs.form.resetValidation()
		},	
	},
	created: function(){
		if( this.preFill ){
			for( var key in this.preFill	){
				this[key] = this.preFill[key]
			}
		} 
		if( this.role == "client" ){
			// this.$store.dispatch("fetch", "organisations")
		}

	}
};
</script>
